import { render } from "./LaptopIcon.vue?vue&type=template&id=1c4ba8d5"
import script from "./LaptopIcon.vue?vue&type=script&lang=js"
export * from "./LaptopIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__